import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $integrationsStore } from '@lib/store';
import { IntegrationList } from './widgets';
import { PageContainer, Spinner } from '@shared/widgets';

export const IntegrationsPage = () => {
  const integrationsStore = useUnit($integrationsStore.store);

  useEffect(() => {
    $integrationsStore.events.get();
  }, []);

  return (
    <PageContainer title='Integrations' header='Integrations'>
      {integrationsStore.loading ? <Spinner /> : <IntegrationList list={integrationsStore.data} />}
    </PageContainer>
  );
};
